import styled from 'styled-components';

const getPaddingLeft = level => {
  return level * 8;
};

export const RldToolNode = styled.button`
  width: calc(100% - 10px);
  color: ${props => (props.isSelected ? 'white' : '#46546A')};
  background: ${props =>
    props.isSelected ? '#7994BB' : props.isMoved ? '#edf1f5' : 'white'};
  padding-top: ${props => (props.isSelected ? '5px' : '0px')};
  padding-bottom: ${props => (props.isSelected ? '5px' : '0px')};
  display: flex;
  text-align: start;
  margin-bottom: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 13px;
  padding-left: ${props => getPaddingLeft(props.level)}px;
`;

export const RldToolClosedIcon = styled.img`
  display: inline-flex;
  width: 10px;
  height: 10px;
  margin-top: 5px;
`;

export const RldToolOpenedIcon = styled.img`
  display: inline-flex;
  width: 10px;
  height: 15px;
  margin-top: 2px;
`;

export const RldToolNodeLabel = styled.span`
  padding-left: 5px;
  font-weight: ${props => (props.font ? 'bold' : 'normal')};
`;
